import React from 'react';
import { styled } from '@linaria/react';
import { animated } from 'react-spring';

import useBoop from '@/hooks/use-boop';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  x?: number;
  y?: number;
  rotation?: number;
  scale?: number;
  timing?: number;
}

function Boop({
  x,
  y,
  rotation,
  scale,
  timing,
  children,
  ...delegated
}: Props) {
  const [style, trigger] = useBoop({
    x,
    y,
    rotation,
    scale,
    timing,
  });

  return (
    <Wrapper onMouseEnter={trigger} style={style} {...delegated}>
      {children}
    </Wrapper>
  );
}

const Wrapper = styled(animated.span)`
  display: inline-block;
  backface-visibility: hidden;
`;

export default Boop;
